<div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="20px" fxFill [ngClass]="{'wrapper':true}">
   <div class="container">
      <div class="text-center">
         <a [routerLink]="['/']"><img src="../../../assets/images/logo.png" class="logo"></a>
      </div>
      <ng-content></ng-content>
   </div>
</div>